'use client'

import { memo, useEffect } from 'react'

declare global {
  interface Window {
    TWEBSHOP: {
      config: string
      id: string | null
      maxServiceCount: number
      theme: { sticky: { offset: number; zIndex: number } }
    }
  }
}

const Tomas = ({ id }: { id: string }) => {
  useEffect(() => {
    window.TWEBSHOP = {
      config: 'Surselva_tds',
      id: null,
      maxServiceCount: 10,
      theme: {
        sticky: {
          offset: 80,
          zIndex: 1
        }
      }
    }

    const script = document.createElement('script')
    script.src =
      'https://twebshop.tomas-travel.com/app/experience/widget/app.js'
    document.body.appendChild(script)

    // Prevent lenis scroll on twebshop with observer
    const observer = new MutationObserver(() => {
      const twebshop = document.querySelectorAll('#twebshop')
      if (twebshop.length > 0) {
        Array.from(twebshop).forEach((twebshop) => {
          twebshop.setAttribute('data-lenis-prevent', '')
        })
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })

    return () => {
      observer.disconnect()
      document.body.removeChild(script)
    }
  }, [id])

  return (
    <>
      <style>{`
        #twebshop {
          --tw-button-color: var(--color-accent-300);
          --tw-button-text-color: #fff;
          --tw-button-price-color: var(--color-accent-300);
          --tw-button-price-text-color: #fff;
          --tw-box-color: var(--color-accent-300);
          --tw-box-text-color: #fff;
          --tw-booking-color: var(--color-neutral-200);
          --tw-booking-text-color: var(--color-neutral-600);
          border-radius: 0;
          font-family: var(--font-primary);
        }

        #twebshop .t-wrapper {
          margin: 0 !important;
          max-width: 100% !important;
        }

        #twebshop  .t-wrapper .rounded-md {
          border-radius: 0 !important;
        }

        #twebshop  .t-wrapper #twebshop .py-2 {
          padding-top: 0 !important;
          padding-bottom: 0 !important;
        }

        #twebshop .rounded-l,
        #twebshop .rounded-r,
        #twebshop .rounded {
          border-radius: 0 !important;
        }
        #twebshop .t-modal {
          z-index: 9999999 !important;
        }
      `}</style>
      <div id="tomas-widget">
        <tws-experience-widget data-id={id}></tws-experience-widget>
      </div>
    </>
  )
}

export default memo(Tomas)
